export function scopeToProject<T extends { projectId: string }>(
  records: readonly T[] | undefined,
  projectId: string | null,
): T[] {
  if (!projectId || !records) return [];
  return records.filter((record) => record.projectId === projectId);
}

export function scopeToTask<T extends { projectId: string; chatId: string }>(
  records: readonly T[] | undefined,
  projectId: string | null,
  chatId: string | null,
): T[] {
  if (!projectId || !chatId || !records) return [];
  return records.filter((record) => record.projectId === projectId && record.chatId === chatId);
}
